//import React from 'react';

//const InfoBlockWInfo = ({ label, value, info }) => {
//    if (!value) return null;

//    return (
//        <div className="info-block">
//            <div className="info-label">
//                {label}
//                {info && (
//                    <span className="info-icon" tabIndex="0">
//                        ℹ️
//                        <span className="tooltip">{info}</span>
//                    </span>
//                )}
//            </div>
//            <div className="info-value">{value}</div>
//        </div>
//    );
//};

//export default InfoBlockWInfo;


import React from 'react';
import InfoIcon from '../../SVG/InfoIcon';

const InfoBlockWInfo = ({ label, value, info }) => {
    if (!value) return null;

    return (
        <div className="info-block">
            <div className="info-label">
                {label}
                {info && (
                    <span className="info-icon" tabIndex="0">
                        <InfoIcon size={16} color="var(--primary-color)" />
                        <span className="tooltip">{info}</span>
                    </span>
                )}
            </div>
            <div className="info-value">{value}</div>
        </div>
    );
};

export default InfoBlockWInfo;